import { useMemo } from "react";

import { useAppLanguageStore } from "app/stores/useAppLanguageStore";
import { countryNameFromCode } from "utils/countryNames";

export function useCountryNames(countryCode: string | null) {
  const appLanguage = useAppLanguageStore((state) => state.appLanguage);
  return useMemo(
    () => countryNameFromCode(appLanguage, countryCode) ?? null,
    [appLanguage, countryCode],
  );
}
